import { PDKAddIcon } from '@/components/ui/pdk-icons';
import HoverClickStay from '@/components/ux/hover-click-stay';
import { toast } from '@/hooks/use-toast';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import InlineTextInput from '../../ui/inline-text-input';

// TECH DEBT: consolidate name editors
const PrimaryCustomerNameEditor = ({
  id,
  fullName,
  shortId,
}: {
  id: Trade['id'];
  fullName: string;
  shortId: string;
}) => {
  const [fullNameValue, setFullNameValue] = useState(fullName);

  const updateDealAssociatedMutation = useMutation({
    onMutate: async ({ fullName }: { fullName: string }) => {
      tradesStore.updateTrade(id, {
        full_name: fullName,
      });
    },
    mutationFn: async ({ fullName }: { fullName: string }) => {
      // /api/trades/:trade_id/full_name
      const response = await pdkAxios.post(`/trades/${id}/full_name`, {
        full_name: fullName,
      });
      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating deal associated', error, variables);
    },
  });

  const handlePrimaryCustomerNameChange = useCallback(
    debounce((newPrimaryCustomerName: string) =>
      // newPrimaryCustomerName: string
      {
        updateDealAssociatedMutation.mutate({
          fullName: newPrimaryCustomerName,
        });
        // toast({
        //   title: 'Name change not implemented',
        //   description: `Name change is not implemented yet. ${newPrimaryCustomerName}`,
        // });
      }, 1000),
    [],
  );

  useEffect(() => {
    if (fullNameValue === fullName) return;

    handlePrimaryCustomerNameChange(fullNameValue);
  }, [fullNameValue]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setFullNameValue(e.target.value);
  }, []);

  useEffect(() => {
    setFullNameValue(fullName);
  }, [fullName]);

  return (
    <div className="flex flex-col gap-2 w-full">
      <HoverClickStay
        key="customer-hover"
        tether={
          <div
            onClick={() => {
              toast({
                title: 'Adding secondary owner not implemented',
                description: 'Adding secondary owner is not implemented yet',
              });
            }}
          >
            <PDKAddIcon />
          </div>
        }
      >
        <InlineTextInput
          key={`primary-customer-name-editor-${shortId}-title`}
          placeholder="Customer Name"
          value={fullNameValue}
          wrapperClassName="w-full"
          className="w-full h-fit text-black py-0 text-2xl!  tracking-tight"
          readOnly
        />
      </HoverClickStay>
      <InlineTextInput
        key={`primary-customer-name-editor-${shortId}-input`}
        placeholder="Customer Name"
        value={fullNameValue}
        // className="w-full!"
        wrapperClassName="w-full"
        className="w-full!"
        onChange={onChange}
        onBlur={() => {
          // if (!deal) {
          //   return;
          // }
          // redirectToInformativeDealUrl({
          //   primaryCustomerFullName: fullNameValue,
          //   vehicle: deal.vehicle,
          //   primarySalesRep: deal.primary_sales_rep,
          //   secondarySalesRep: deal.secondary_sales_rep,
          //   shortId: deal.short_id,
          // });
        }}
      />
    </div>
  );
};

export default PrimaryCustomerNameEditor;
